import {
  type IContactInfo,
  ParentState,
  getCartInitialContext,
  getAirChfarInitialContext,
} from "@hopper-b2b/checkout";
import { AirChfarExerciseDiscountInitialContext } from "@hopper-b2b/checkout";
import {
  type IPerson,
  type ISelectedTrip,
  type PersonId,
  type SessionInfo,
  SupportStatus,
  type TripDetails,
} from "@hopper-b2b/types";

import ClientLogo from "../../assets/client/client-logo.webp";
import type { FlightMachineContext } from "./types";

export const getInitialFlightMachineContext =
  function (): FlightMachineContext {
    return {
      ...getCartInitialContext(),
      sessionInfo: {} as SessionInfo,
      clientAssets: {
        logo: ClientLogo,
      },
      flightSearch: {
        tripCategory: undefined,
        destination: null,
        origin: null,
        departureDate: null,
        returnDate: null,
        originCountryCode: "",
        destinationCountryCode: "",
        multicityRoutes: [],
      },
      flightShop: {
        tripDetails: {} as TripDetails,
        selectedTrip: {} as ISelectedTrip,
        shopPricingInfo: {
          fare: undefined,
        },
        departureLabel: "",
        returnLabel: undefined,
        airports: undefined,
        selectedMulticityTrips: [],
      },
      common: {
        tripPricing: undefined,
      },
      featureFlags: {},
      [ParentState.priceFreeze]: {
        priceFreezeId: undefined,
        priceFreezeView: undefined,
      },
      [ParentState.cancelForAnyReason]: {
        cfarQuoteId: undefined,
        cfarOffers: undefined,
        selectedOffer: undefined,
      },
      [ParentState.changeForAnyReason]: { ...getAirChfarInitialContext() },
      [ParentState.changeForAnyReasonDiscount]:
        AirChfarExerciseDiscountInitialContext,
      [ParentState.passengerInformation]: {
        selectedPassengerIds: [] as Array<PersonId>,
        selectedLapInfantIds: [] as Array<PersonId>,
        userPassengers: [] as Array<IPerson>,
        addPassport: false,
        infantOnlyError: false,
        visited: false,
      },
      [ParentState.contactInformation]: {
        contactInfo: {} as IContactInfo,
        visited: false,
      },
      [ParentState.passport]: {
        error: undefined,
      },
      [ParentState.seatSelection]: {
        selectedSeats: [],
        selectedSeatSegments: [],
        cheapestSeat: undefined,
        seatMapHtml: undefined,
        seatMapRequest: undefined,
        seatsInfo: undefined,
        seatMapAvailable: undefined,
        visited: false,
        skipSeatSelection: false,
      },
      [ParentState.review]: {
        visited: false,
      },
      [ParentState.payment]: {
        paymentSessionToken: undefined,
        paymentQuoteToken: undefined,
        error: undefined,
        visited: false,
      },
      [ParentState.bookingConfirmation]: {},
      [ParentState.disruption]: {
        selectedOffers: [],
        offersResponse: [],
      },
      [ParentState.vipSupport]: {
        supportStatus: SupportStatus.vip,
      },
      [ParentState.priceDrop]: { candidateId: undefined },
    };
  };
